export enum FirestoreChannelType {
  Team = "Team",
  DirectMessage = "DirectMessage",
}
